import React, { memo, useCallback } from 'react';
import { connect } from 'react-redux';
import SliderListItem from '../../../../../../list-items/SliderListItem/SliderListItem';
import { createActions } from '../../../../store';

const WaveLayerBarWidth = memo(({ index, barWidth, maxBarWidth, updateWaveLayerCustomOptions }) => {
    const onWidthChange = useCallback(
        (value) => updateWaveLayerCustomOptions(index, "barWidth", value),
        [index]
    );
   
    return (
        <SliderListItem
            title="Bar Width"
            value={barWidth}
            displayMultiplier={100 / maxBarWidth}
            onValueChange={onWidthChange}
            min={0}
            max={100}
            step={1}
        />
    );
});

const mapStateToProps = (state, { index }) => {
    const { barWidth } = state.createPreview.present.videoSettings.visualizer.waveCircles[index].customOptions;
    const { maxBarWidth } = state.create.maxValues;
    return { barWidth, maxBarWidth };
}

const mapDispatchToProps = (dispatch) => ({
    updateWaveLayerCustomOptions: (index, key, value) => dispatch(createActions.updateWaveLayerCustomOptions(index, key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(WaveLayerBarWidth);
